import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import constructionFox from "@/assets/construction-fox.png";

const Apps = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-24 pb-16 bg-secondary/30">
        <div className="container mx-auto px-4">
          <div className="flex flex-col items-center justify-center min-h-[60vh]">
            <img 
              src={constructionFox} 
              alt="Under Construction" 
              className="w-64 h-64 mb-8"
            />
            <h1 className="text-4xl md:text-5xl font-bold text-center">
              Under Construction
            </h1>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Apps;
